export default {
  prePopulation: {
    busSearchOptions: {
      geoField: {
        value: 50.0,
      },
      sortingDetails: [
        {
          field: 'geo',
          order: 'ASC',
        },
      ],
    },
  },
};
